import axiosIns from '@axios'

const $http = axiosIns

export const $getCountries = async (filters: object) => {
    return await $http.get('/countries/', {params: filters})
}

export const $createCountry = async (payload: object) => {
    return await $http.post('/countries/', payload)
}

export const $deleteCountry = async (id: number) => {
    return await $http.delete(`/countries/${id}/`)
}

export const $updateCountry = async (id: number, payload: object) => {
    return await $http.patch(`/countries/${id}/`, payload)
}

export const $getCities = async (filters: object) => {
    return await $http.get('/cities/', {params: filters})
}

export const $createCity = async (payload: object) => {
    return await $http.post('/cities/', payload)
}

export const $deleteCity = async (id: number) => {
    return await $http.delete(`/cities/${id}/`)
}

export const $updateCity = async (id: number, payload: object) => {
    return await $http.patch(`/cities/${id}/`, payload)
}


export const $getSignTextGroups = async (filters: object) => {
    return await $http.get('/sign-text-groups/', { params: filters })
}

export const $createSignTextGroup = async (payload: object) => {
    return await $http.post('/sign-text-groups/', payload)
}

export const $deleteSignTextGroup = async (id: number) => {
    return await $http.delete(`/sign-text-groups/${id}/`)
}

export const $updateSignTextGroup = async (id: number, payload: object) => {
    return await $http.patch(`/sign-text-groups/${id}/`, payload)
}

export const $getSignTextGroupOptions = async () => {
    return await $http.options('/sign-text-groups/')
}

export const $getSignTexts = async (filters: object) => {
    return await $http.get('/sign-texts/', { params: filters })
}

export const $createSignTexts = async (payload: object) => {
    return await $http.post('/sign-texts/', payload)
}

export const $deleteSignTexts = async (id: number) => {
    return await $http.delete(`/sign-texts/${id}/`)
}

export const $updateSignTexts = async (id: number, payload: object) => {
    return await $http.patch(`/sign-texts/${id}/`, payload)
}

export const $uploadSignTexts = async (payload: object) => {
    return await $http.post('/glossary-upload/', payload)
}

export const $multipleDeleteSignTexts = async (payload: object) => {
    return await $http.post('/multiple-delete-sign-texts/', payload)
}

export const $exportExcelGlossarySettings = async (payload: object) => {
    return await $http.post('/export-excel-sign-texts/', payload)
}

export const $exportExcelGlossaryPictogramSettings = async (payload: object) => {
    return await $http.post('/export-excel-sign-pictograms/', payload)
}

// Sign Pictogram Catalogues
export const $getSignPictogramCatalogues = async (filters: object) => {
    return await $http.get('/sign-pictogram-catalogues/', { params: filters })
}

export const $createSignPictogramCatalogue = async (payload: object) => {
    return await $http.post('/sign-pictogram-catalogues/', payload)
}

export const $deleteSignPictogramCatalogue = async (id: number) => {
    return await $http.delete(`sign-pictogram-catalogues/${id}/`)
}

export const $updateSignPictogramCatalogue = async (id: number, payload: object) => {
    return await $http.patch(`sign-pictogram-catalogues/${id}/`, payload)
}

export const $getSignPictogramCatalogueOptions = async () => {
    return await $http.options('/sign-pictogram-catalogues/')
}

// Sign Type Catalogues
export const $getSignCatalogues = async (filters: object) => {
    return await $http.get('/sign-catalogues/', { params: filters })
}

export const $createSignCatalogue = async (payload: object) => {
    return await $http.post('/sign-catalogues/', payload)
}

export const $deleteSignCatalogue = async (id: number) => {
    return await $http.delete(`/sign-catalogues/${id}/`)
}

export const $updateSignCatalogue = async (id: number, payload: object) => {
    return await $http.patch(`/sign-catalogues/${id}/`, payload)
}

export const $getSignCatalogueOptions = async () => {
    return await $http.options('/sign-catalogues/')
}

export const $copyMultipleSignTypes = async (payload: object) => {
    return await $http.post('/copy-multiple-sign-types/', payload)
}

export const $getSignTypes = async (filters: object) => {
    return await $http.get('/sign-types/', { params: filters })
}

export const $createSignType = async (payload: object) => {
    return await $http.post('/sign-types/', payload)
}

export const $updateSignType = async (id: number, payload: object) => {
    return await $http.patch(`/sign-types/${id}/`, payload)
}

export const $exportExcelSignTypes = async (payload: object) => {
    return await $http.post('/export-excel-sign-types/', payload)
}

export const $getSignTemplateTypeCatalogues = async (filters: object) => {
    return await $http.get('/sign-template-type-catalogues/', { params: filters })
}

export const $createSignTemplateTypeCatalogue = async (payload: object) => {
    return await $http.post('/sign-template-type-catalogues/', payload)
}

export const $deleteSignTemplateTypeCatalogue = async (id: number) => {
    return await $http.delete(`/sign-template-type-catalogues/${id}/`)
}

export const $updateSignTemplateTypeCatalogue = async (id: number, payload: object) => {
    return await $http.patch(`/sign-template-type-catalogues/${id}/`, payload)
}

export const $getSignTemplateTypeCatalogueOptions = async () => {
    return await $http.options('/sign-template-type-catalogues/')
}

export const $getSignTemplateTypes = async (filters: object) => {
    return await $http.get('/sign-template-types/', { params: filters })
}

export const $createSignTemplateType = async (payload: object) => {
    return await $http.post('/sign-template-types/', payload)
}

export const $deleteSignTemplateType = async (id: number) => {
    return await $http.delete(`/sign-template-types/${id}/`)
}

export const $updateSignTemplateType = async (id: number, payload: object) => {
    return await $http.patch(`/sign-template-types/${id}/`, payload)
}

export const $getFunctionalAreaCatalogues = async (filters: object) => {
    return await $http.get('/functional-area-catalogues/', { params: filters })
}

export const $createFunctionalAreaCatalogue = async (payload: object) => {
    return await $http.post('/functional-area-catalogues/', payload)
}

export const $deleteFunctionalAreaCatalogue = async (id: number) => {
    return await $http.delete(`/functional-area-catalogues/${id}/`)
}

export const $updateFunctionalAreaCatalogue = async (id: number, payload: object) => {
    return await $http.patch(`/functional-area-catalogues/${id}/`, payload)
}

export const $getFunctionalAreaCatalogueOptions = async () => {
    return await $http.options('/functional-area-catalogues/')
}

export const $getFunctionalAreas = async (filters: object) => {
    return await $http.get('/functional-areas/', { params: filters })
}

export const $createFunctionalArea = async (payload: object) => {
    return await $http.post('/functional-areas/', payload)
}

export const $deleteFunctionalArea = async (id: number) => {
    return await $http.delete(`/functional-areas/${id}/`)
}

export const $updateFunctionalArea = async (id: number, payload: object) => {
    return await $http.patch(`/functional-areas/${id}/`, payload)
}

export const $getFunctionalAreaOptions = async () => {
    return await $http.options('/functional-areas/')
}


export const $copyMultipleFunctionalAreas = async (payload: object) => {
    return await $http.post('/copy-multiple-functional-areas/', payload)
}

export const $uploadFunctionalAreas = async (payload: object) => {
    return await $http.post('/functional-areas-upload/', payload)
}

export const $getEventGroups = async (filters: object) => {
    return await $http.get('/event-groups/', { params: filters })
}

export const $createEventGroup = async (payload: object) => {
    return await $http.post('/event-groups/', payload)
}

export const $deleteEventGroup = async (id: number) => {
    return await $http.delete(`/event-groups/${id}/`)
}

export const $updateEventGroup = async (id: number, payload: object) => {
    return await $http.patch(`/event-groups/${id}/`, payload)
}

export const $getEventGroupOptions = async () => {
    return await $http.options('/event-groups/')
}

export const $getSignTypeOptions = async () => {
    return await $http.options('/sign-types/')
}

export const $getTeamLists = async (filters: object) => {
    return await $http.get('/team-lists/', { params: filters })
}

export const $createTeamList = async (payload: object) => {
    return await $http.post('/team-lists/', payload)
}

export const $deleteTeamList = async (id: number) => {
    return await $http.delete(`/team-lists/${id}/`)
}

export const $updateTeamList = async (id: number, payload: object) => {
    return await $http.patch(`/team-lists/${id}/`, payload)
}
